@if (groups?.length > 0) {
  <div class="progress-container">
    @for (group of groups; track index; let index = $index) {
      <div [style.width]="100 / groups.length + '%'" class="progress">
        <div class="determinate" [style.width]="(100 / group.count) * group.current + '%'"></div>
      </div>
    }
  </div>
}
